/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  ResponseStatus,
  responseStatusToNumber,
  responseStatusFromJSON,
  responseStatusToJSON,
} from "../ResponseStatus";
import { DebugBar } from "../../DebugBar";
import { HotelList } from "../../Hotel/Hotel";
import { MapDataList } from "../../MapData/MapData";
import { CityList } from "../../City";
import { RegionList } from "../../Region";
import { FilterList } from "../../Hotel/Filter";
import { TravelExpertList } from "../../TravelExpert/TravelExpert";
import { TravelTickerList } from "../../TravelTicker/TravelTicker";
import { Tracking } from "../../Tracking/Tracking";
import { ServiceInformation } from "../../ServiceInformation";
import { FilterInformation } from "../../Search/FilterMeta";

export interface HotelListResponse {
  status: ResponseStatus;
  debugBar?: DebugBar;
  hotelList?: HotelList;
  mapDataList?: MapDataList;
  cityList?: CityList;
  regionList?: RegionList;
  filterList?: FilterList;
  travelExpertList?: TravelExpertList;
  travelTickerList?: TravelTickerList;
  tracking?: Tracking;
  serviceInformation?: ServiceInformation;
  alternativeHotelList?: HotelList;
  filterInformation?: FilterInformation;
}

export interface HotelListRequest {
  isInitialRequest: boolean;
  isWithTravelTicker: boolean;
  isWithTravelExperts: boolean;
  isFinalRequest: boolean;
  isWithServiceInformation: boolean;
  searchUrl: string;
  clientId: string;
  transactionId: string;
}

function createBaseHotelListResponse(): HotelListResponse {
  return {
    status: ResponseStatus.ResponseStatusUnknown,
    debugBar: undefined,
    hotelList: undefined,
    mapDataList: undefined,
    cityList: undefined,
    regionList: undefined,
    filterList: undefined,
    travelExpertList: undefined,
    travelTickerList: undefined,
    tracking: undefined,
    serviceInformation: undefined,
    alternativeHotelList: undefined,
    filterInformation: undefined,
  };
}

export const HotelListResponse = {
  encode(
    message: HotelListResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.status !== ResponseStatus.ResponseStatusUnknown) {
      writer.uint32(8).int32(responseStatusToNumber(message.status));
    }
    if (message.debugBar !== undefined) {
      DebugBar.encode(message.debugBar, writer.uint32(18).fork()).ldelim();
    }
    if (message.hotelList !== undefined) {
      HotelList.encode(message.hotelList, writer.uint32(26).fork()).ldelim();
    }
    if (message.mapDataList !== undefined) {
      MapDataList.encode(
        message.mapDataList,
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.cityList !== undefined) {
      CityList.encode(message.cityList, writer.uint32(42).fork()).ldelim();
    }
    if (message.regionList !== undefined) {
      RegionList.encode(message.regionList, writer.uint32(50).fork()).ldelim();
    }
    if (message.filterList !== undefined) {
      FilterList.encode(message.filterList, writer.uint32(58).fork()).ldelim();
    }
    if (message.travelExpertList !== undefined) {
      TravelExpertList.encode(
        message.travelExpertList,
        writer.uint32(66).fork()
      ).ldelim();
    }
    if (message.travelTickerList !== undefined) {
      TravelTickerList.encode(
        message.travelTickerList,
        writer.uint32(74).fork()
      ).ldelim();
    }
    if (message.tracking !== undefined) {
      Tracking.encode(message.tracking, writer.uint32(82).fork()).ldelim();
    }
    if (message.serviceInformation !== undefined) {
      ServiceInformation.encode(
        message.serviceInformation,
        writer.uint32(90).fork()
      ).ldelim();
    }
    if (message.alternativeHotelList !== undefined) {
      HotelList.encode(
        message.alternativeHotelList,
        writer.uint32(98).fork()
      ).ldelim();
    }
    if (message.filterInformation !== undefined) {
      FilterInformation.encode(
        message.filterInformation,
        writer.uint32(106).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HotelListResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHotelListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = responseStatusFromJSON(reader.int32());
          break;
        case 2:
          message.debugBar = DebugBar.decode(reader, reader.uint32());
          break;
        case 3:
          message.hotelList = HotelList.decode(reader, reader.uint32());
          break;
        case 4:
          message.mapDataList = MapDataList.decode(reader, reader.uint32());
          break;
        case 5:
          message.cityList = CityList.decode(reader, reader.uint32());
          break;
        case 6:
          message.regionList = RegionList.decode(reader, reader.uint32());
          break;
        case 7:
          message.filterList = FilterList.decode(reader, reader.uint32());
          break;
        case 8:
          message.travelExpertList = TravelExpertList.decode(
            reader,
            reader.uint32()
          );
          break;
        case 9:
          message.travelTickerList = TravelTickerList.decode(
            reader,
            reader.uint32()
          );
          break;
        case 10:
          message.tracking = Tracking.decode(reader, reader.uint32());
          break;
        case 11:
          message.serviceInformation = ServiceInformation.decode(
            reader,
            reader.uint32()
          );
          break;
        case 12:
          message.alternativeHotelList = HotelList.decode(
            reader,
            reader.uint32()
          );
          break;
        case 13:
          message.filterInformation = FilterInformation.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): HotelListResponse {
    return {
      status: isSet(object.status)
        ? responseStatusFromJSON(object.status)
        : ResponseStatus.ResponseStatusUnknown,
      debugBar: isSet(object.debugBar)
        ? DebugBar.fromJSON(object.debugBar)
        : undefined,
      hotelList: isSet(object.hotelList)
        ? HotelList.fromJSON(object.hotelList)
        : undefined,
      mapDataList: isSet(object.mapDataList)
        ? MapDataList.fromJSON(object.mapDataList)
        : undefined,
      cityList: isSet(object.cityList)
        ? CityList.fromJSON(object.cityList)
        : undefined,
      regionList: isSet(object.regionList)
        ? RegionList.fromJSON(object.regionList)
        : undefined,
      filterList: isSet(object.filterList)
        ? FilterList.fromJSON(object.filterList)
        : undefined,
      travelExpertList: isSet(object.travelExpertList)
        ? TravelExpertList.fromJSON(object.travelExpertList)
        : undefined,
      travelTickerList: isSet(object.travelTickerList)
        ? TravelTickerList.fromJSON(object.travelTickerList)
        : undefined,
      tracking: isSet(object.tracking)
        ? Tracking.fromJSON(object.tracking)
        : undefined,
      serviceInformation: isSet(object.serviceInformation)
        ? ServiceInformation.fromJSON(object.serviceInformation)
        : undefined,
      alternativeHotelList: isSet(object.alternativeHotelList)
        ? HotelList.fromJSON(object.alternativeHotelList)
        : undefined,
      filterInformation: isSet(object.filterInformation)
        ? FilterInformation.fromJSON(object.filterInformation)
        : undefined,
    };
  },

  toJSON(message: HotelListResponse): unknown {
    const obj: any = {};
    message.status !== undefined &&
      (obj.status = responseStatusToJSON(message.status));
    message.debugBar !== undefined &&
      (obj.debugBar = message.debugBar
        ? DebugBar.toJSON(message.debugBar)
        : undefined);
    message.hotelList !== undefined &&
      (obj.hotelList = message.hotelList
        ? HotelList.toJSON(message.hotelList)
        : undefined);
    message.mapDataList !== undefined &&
      (obj.mapDataList = message.mapDataList
        ? MapDataList.toJSON(message.mapDataList)
        : undefined);
    message.cityList !== undefined &&
      (obj.cityList = message.cityList
        ? CityList.toJSON(message.cityList)
        : undefined);
    message.regionList !== undefined &&
      (obj.regionList = message.regionList
        ? RegionList.toJSON(message.regionList)
        : undefined);
    message.filterList !== undefined &&
      (obj.filterList = message.filterList
        ? FilterList.toJSON(message.filterList)
        : undefined);
    message.travelExpertList !== undefined &&
      (obj.travelExpertList = message.travelExpertList
        ? TravelExpertList.toJSON(message.travelExpertList)
        : undefined);
    message.travelTickerList !== undefined &&
      (obj.travelTickerList = message.travelTickerList
        ? TravelTickerList.toJSON(message.travelTickerList)
        : undefined);
    message.tracking !== undefined &&
      (obj.tracking = message.tracking
        ? Tracking.toJSON(message.tracking)
        : undefined);
    message.serviceInformation !== undefined &&
      (obj.serviceInformation = message.serviceInformation
        ? ServiceInformation.toJSON(message.serviceInformation)
        : undefined);
    message.alternativeHotelList !== undefined &&
      (obj.alternativeHotelList = message.alternativeHotelList
        ? HotelList.toJSON(message.alternativeHotelList)
        : undefined);
    message.filterInformation !== undefined &&
      (obj.filterInformation = message.filterInformation
        ? FilterInformation.toJSON(message.filterInformation)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<HotelListResponse>): HotelListResponse {
    const message = createBaseHotelListResponse();
    message.status = object.status ?? ResponseStatus.ResponseStatusUnknown;
    message.debugBar =
      object.debugBar !== undefined && object.debugBar !== null
        ? DebugBar.fromPartial(object.debugBar)
        : undefined;
    message.hotelList =
      object.hotelList !== undefined && object.hotelList !== null
        ? HotelList.fromPartial(object.hotelList)
        : undefined;
    message.mapDataList =
      object.mapDataList !== undefined && object.mapDataList !== null
        ? MapDataList.fromPartial(object.mapDataList)
        : undefined;
    message.cityList =
      object.cityList !== undefined && object.cityList !== null
        ? CityList.fromPartial(object.cityList)
        : undefined;
    message.regionList =
      object.regionList !== undefined && object.regionList !== null
        ? RegionList.fromPartial(object.regionList)
        : undefined;
    message.filterList =
      object.filterList !== undefined && object.filterList !== null
        ? FilterList.fromPartial(object.filterList)
        : undefined;
    message.travelExpertList =
      object.travelExpertList !== undefined && object.travelExpertList !== null
        ? TravelExpertList.fromPartial(object.travelExpertList)
        : undefined;
    message.travelTickerList =
      object.travelTickerList !== undefined && object.travelTickerList !== null
        ? TravelTickerList.fromPartial(object.travelTickerList)
        : undefined;
    message.tracking =
      object.tracking !== undefined && object.tracking !== null
        ? Tracking.fromPartial(object.tracking)
        : undefined;
    message.serviceInformation =
      object.serviceInformation !== undefined &&
      object.serviceInformation !== null
        ? ServiceInformation.fromPartial(object.serviceInformation)
        : undefined;
    message.alternativeHotelList =
      object.alternativeHotelList !== undefined &&
      object.alternativeHotelList !== null
        ? HotelList.fromPartial(object.alternativeHotelList)
        : undefined;
    message.filterInformation =
      object.filterInformation !== undefined &&
      object.filterInformation !== null
        ? FilterInformation.fromPartial(object.filterInformation)
        : undefined;
    return message;
  },
};

function createBaseHotelListRequest(): HotelListRequest {
  return {
    isInitialRequest: false,
    isWithTravelTicker: false,
    isWithTravelExperts: false,
    isFinalRequest: false,
    isWithServiceInformation: false,
    searchUrl: "",
    clientId: "",
    transactionId: "",
  };
}

export const HotelListRequest = {
  encode(
    message: HotelListRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isInitialRequest === true) {
      writer.uint32(32).bool(message.isInitialRequest);
    }
    if (message.isWithTravelTicker === true) {
      writer.uint32(40).bool(message.isWithTravelTicker);
    }
    if (message.isWithTravelExperts === true) {
      writer.uint32(48).bool(message.isWithTravelExperts);
    }
    if (message.isFinalRequest === true) {
      writer.uint32(56).bool(message.isFinalRequest);
    }
    if (message.isWithServiceInformation === true) {
      writer.uint32(64).bool(message.isWithServiceInformation);
    }
    if (message.searchUrl !== "") {
      writer.uint32(10).string(message.searchUrl);
    }
    if (message.clientId !== "") {
      writer.uint32(18).string(message.clientId);
    }
    if (message.transactionId !== "") {
      writer.uint32(26).string(message.transactionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HotelListRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHotelListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.isInitialRequest = reader.bool();
          break;
        case 5:
          message.isWithTravelTicker = reader.bool();
          break;
        case 6:
          message.isWithTravelExperts = reader.bool();
          break;
        case 7:
          message.isFinalRequest = reader.bool();
          break;
        case 8:
          message.isWithServiceInformation = reader.bool();
          break;
        case 1:
          message.searchUrl = reader.string();
          break;
        case 2:
          message.clientId = reader.string();
          break;
        case 3:
          message.transactionId = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): HotelListRequest {
    return {
      isInitialRequest: isSet(object.isInitialRequest)
        ? Boolean(object.isInitialRequest)
        : false,
      isWithTravelTicker: isSet(object.isWithTravelTicker)
        ? Boolean(object.isWithTravelTicker)
        : false,
      isWithTravelExperts: isSet(object.isWithTravelExperts)
        ? Boolean(object.isWithTravelExperts)
        : false,
      isFinalRequest: isSet(object.isFinalRequest)
        ? Boolean(object.isFinalRequest)
        : false,
      isWithServiceInformation: isSet(object.isWithServiceInformation)
        ? Boolean(object.isWithServiceInformation)
        : false,
      searchUrl: isSet(object.searchUrl) ? String(object.searchUrl) : "",
      clientId: isSet(object.clientId) ? String(object.clientId) : "",
      transactionId: isSet(object.transactionId)
        ? String(object.transactionId)
        : "",
    };
  },

  toJSON(message: HotelListRequest): unknown {
    const obj: any = {};
    message.isInitialRequest !== undefined &&
      (obj.isInitialRequest = message.isInitialRequest);
    message.isWithTravelTicker !== undefined &&
      (obj.isWithTravelTicker = message.isWithTravelTicker);
    message.isWithTravelExperts !== undefined &&
      (obj.isWithTravelExperts = message.isWithTravelExperts);
    message.isFinalRequest !== undefined &&
      (obj.isFinalRequest = message.isFinalRequest);
    message.isWithServiceInformation !== undefined &&
      (obj.isWithServiceInformation = message.isWithServiceInformation);
    message.searchUrl !== undefined && (obj.searchUrl = message.searchUrl);
    message.clientId !== undefined && (obj.clientId = message.clientId);
    message.transactionId !== undefined &&
      (obj.transactionId = message.transactionId);
    return obj;
  },

  fromPartial(object: DeepPartial<HotelListRequest>): HotelListRequest {
    const message = createBaseHotelListRequest();
    message.isInitialRequest = object.isInitialRequest ?? false;
    message.isWithTravelTicker = object.isWithTravelTicker ?? false;
    message.isWithTravelExperts = object.isWithTravelExperts ?? false;
    message.isFinalRequest = object.isFinalRequest ?? false;
    message.isWithServiceInformation = object.isWithServiceInformation ?? false;
    message.searchUrl = object.searchUrl ?? "";
    message.clientId = object.clientId ?? "";
    message.transactionId = object.transactionId ?? "";
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
